export const WHATSAPP_NUMBER = "5548999631298";

export const whatsappUrl = (message) => {
  const base = `https://api.whatsapp.com/send?phone=${WHATSAPP_NUMBER}`;
  return message ? `${base}&text=${encodeURIComponent(message)}` : base;
};
